export default "__VITE_ASSET__BIr43Yu5__"